import React from "react";
import CarouselSlide1 from '../data/carousel/1.webp';
import Islands from '../../components/Islands';
import LandingHeader from "../../components/LandingHeader";
import SearchBar from "../../components/SearchBar";

export default function App() {
  return (
    <div className="scroll-smooth">

      {/* HERO */}
      <main className="
        relative w-full min-h-screen
        flex flex-col items-center justify-center text-center
        px-4 sm:px-6
      ">

        {/* Background */}
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <img
            src={CarouselSlide1}
            alt="Comores beach"
            className="h-full w-full object-cover blur-sm sm:blur-md scale-105"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        {/* Header */}
        <LandingHeader />

        {/* Content */}
        <div className="
          flex flex-col items-center justify-center text-center
          w-full max-w-6xl
          pt-24 sm:pt-28
        ">

          <h2 className="
            text-3xl sm:text-5xl lg:text-6xl xl:text-7xl
            font-extrabold text-white drop-shadow-lg
            leading-tight
            max-w-3xl xl:max-w-5xl
          ">
            Réservez votre hôtel aux Comores
          </h2>

          <p className="
            mt-4 sm:mt-6
            text-sm sm:text-lg lg:text-xl
            text-gray-200
            max-w-xl sm:max-w-2xl xl:max-w-3xl
          ">
            Trouvez les meilleurs hôtels aux Comores au meilleur prix.
            Réservation simple, rapide et sécurisée.
          </p>

          {/* SEARCH */}
          <div className="w-full mt-8 sm:mt-8">
            <SearchBar />
          </div>

        </div>

        {/* Scroll indicator */}
        <div className="
          hidden sm:block
          absolute bottom-8 left-1/2 -translate-x-1/2
          animate-bounce text-white
        ">
          ↓
        </div>

      </main>

      {/* ISLANDS */}
      <Islands />

    </div>
  );
}